import * as XLSX from "xlsx";

const DEVICE_CSV_COLUMNS = (t) => [
    {
        key: "name",
        header: t("common.name"),
        value: (device) =>
            device.bus_number === null
                ? device.name
                : t("devices.tracking.bus_numer.prefix") + device.name
    },
    {
        key: "serial",
        header: t("common.serialNumber"),
        value: (device) => device.serial
    },
    {
        key: "cochera",
        header: t("devices.tracking.config.location"),
        value: (device) => device.cochera_name || ""
    },
    {
        key: "status",
        header: t("common.status"),
        value: (device) => getDeviceStatus(device, t)
    },
    {
        key: "tracker_status",
        header: t("devices.tracking.config.status.tooltip.title"),
        value: (device) => getTrackerStatus(device, t)
    },
    {
        key: "tracker_battery",
        header: t("devices.tracker_battery"),
        value: (device) =>
            device.tracker_battery_level !== null &&
            device.tracker_battery_level !== undefined
                ? `${device.tracker_battery_level}%`
                : t("devices.tracking.config.status.not_available")
    },
    {
        key: "connection_status",
        header: t("devices.filters.conection.title"),
        value: (device) => device.statusConnection.statusText
    },
    {
        key: "model",
        header: t("common.model"),
        value: (device) => device.model
    },
    {
        key: "developer",
        header: t("common.manufacturer"),
        value: (device) => device.manufacturer
    },
    {
        key: "software",
        header: t("common.software"),
        value: (device) => device.soft_version
    }
];

const getDeviceStatus = (device, t) => {
    switch (device.statusResult) {
        case 0:
            return t("common.correct");

        case 1:
            return t("common.warning");

        case 2:
            return t("common.error");

        default:
            return t("common.unknown");
    }
};

const getTrackerStatus = (device, t) => {
    switch (device.tracker_status) {
        case 1:
            return t("devices.tracking.config.status.configured");

        case 2:
            return t("devices.tracking.config.status.active");

        case 3:
            return t("devices.tracking.config.status.in_use");

        case 4:
            return t("devices.tracking.config.status.retired");

        case 5:
            return t("devices.tracking.config.status.maintenance");

        case 6:
            return t("devices.tracking.config.status.no_signal");

        default:
            return t("devices.tracking.config.status.not_available");
    }
};

const getExportColumns = (devices, t, hasEmtAdminRole) => {
    const hasEmt = devices.some(
        (device) => device.program_type?.toString() === "2"
    );

    return DEVICE_CSV_COLUMNS(t).filter((column) => {
        if (column.key === "tracker_status") {
            return hasEmt;
        }

        if (column.key === "tracker_battery") {
            return hasEmt && !hasEmtAdminRole;
        }

        return true;
    });
};

const getExportData = (devices, columns) => {
    return devices.map((device) => {
        const row = {};

        columns.forEach((column) => {
            row[column.header] = column.value(device);
        });

        return row;
    });
};

const escapeCsvValue = (value) => {
    if (value === null || value === undefined) {
        return "";
    }

    const text = String(value)
        .replace(/\r?\n|\r/g, " ")
        .replace(/"/g, '""');

    return `"${text}"`;
};

export const exportDevicesToCsv = (devices, hasEmtDevices, t, hasEmtAdminRole) => {
    if (!devices || devices.length === 0) {
        return;
    }

    const columns = getExportColumns(devices, t, hasEmtAdminRole);

    const header = columns
        .map((column) => escapeCsvValue(column.header))
        .join(";");

    const rows = devices.map((device) =>
        columns
            .map((column) => escapeCsvValue(column.value(device)))
            .join(";")
    );

    const csv = [
        header,
        ...rows
    ].join("\r\n");

    const blob = new Blob(
        ["\uFEFF" + csv],
        {
            type: "text/csv;charset=utf-8;"
        }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    const now = new Date();

    const date = now.toISOString().slice(0, 10);
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");

    link.download = `devices_${date}_${hour}-${minute}.csv`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export const exportDevicesToExcel = (devices, hasEmtDevices, t, hasEmtAdminRole) => {
    if (!devices || devices.length === 0) {
        return;
    }

    const columns = getExportColumns(devices, t, hasEmtAdminRole);

    const data = getExportData(devices, columns);

    const worksheet = XLSX.utils.json_to_sheet(data);

    worksheet["!cols"] = [
        { wch: 12 }, // Nombre
        { wch: 12 }, // Nº Serie
        { wch: 12 }, // Cochera
        { wch: 15 }, // Estado
        { wch: 20 }, // Estado tracker
        { wch: 18 }, // Batería tracker
        { wch: 35 }, // Estado conexión
        { wch: 15 }, // Modelo
        { wch: 15 }, // Fabricante
        { wch: 15 }  // Software
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Devices"
    );

    const now = new Date();

    const date = now.toISOString().slice(0, 10);
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");

    XLSX.writeFile(
        workbook,
        `devices_${date}_${hour}-${minute}.xlsx`
    );
};